import Enum from "../../../../../../enums/Enum";

const ProceduresEnum = new Enum({
    Cortisone_Injection: {name: "Cortisone Injection"},
    Platelet_Rich_Plasma: {name: "Platelet Rich Plasma (PRP) Injection with Anesthesia (Lidocaine 1%)"},
    Joint_Effusion_Aspiration: {name: "Joint Effusion Aspiration"},
    Hyaluronic_Acid_Joint_Injection: {name: "Hyaluronic Acid Joint Injection"},
    Sciatic_Nerve_Block: {name: "Sciatic Nerve Block"},
    IV_Infusion: {name: "IV Infusion"},
    Cyst_Excision_Aspiration: {name: "Cyst Excision Aspiration"},
    Consussion_Testing: {name: "Consussion Testing"},
    VitaminB_Complex_Injection: {name: "Vitamin B Complex Injection"},
    Detox_Injection: {name: "Detox Injection"},
    Quaddle_Neural_Therapy: {name: "Quaddle Neural Therapy"},
    Autohemotherapy: {name: "Autohemotherapy"},
    VitaminD_Injection: {name: "Vitamin D Injection"},
    IM_Injection: {name: "IM Injection"},
    Skin_And_Hair_IV_Infusion: {name: "Skin And Hair IV Infusion"},
    Vitamin_Immune_Booster_IV_Infusion: {name: "Vitamin Immune Booster IV Infusion"},
    Anti_Fatigue_IV_Infusion: {name: "Anti Fatigue IV Infusion"},
    Subcutnaeous_Injection_10x25mg: {name: "Subcutnaeous Injection 10x25mg"},
    Executive_Plus_Infusion: {name: "Executive Plus Infusion"},
    Signature_Detox_Infusion: {name: "Signature Detox Infusion"},
    Combat_Jet_Lag_Infusion: {name: "Combat Jet Lag Infusion"},
    Express_IV_Infusion: {name: "Express IV Infusion"},
    Pure_NAD_500: {name: "Pure NAD 500"},
    Pure_NAD_250: {name: "Pure NAD 250"},
    Pure_NAD_100: {name: "Pure NAD 100"},
    Detox_Vacation_Program: {name: "Detox Vacation Program"},
    Other: {name: "Other"}
});

export default ProceduresEnum;